import React from 'react'
import { l } from '@manychat/manyui'

import cm from './ImprovementVariant.module.css'

interface ImprovementVariantProps {
  text: string
  onSelect: (text: string) => void
}

export const ImprovementVariant = React.forwardRef<HTMLElement, ImprovementVariantProps>(
  ({ text, onSelect }, ref) => {
    return (
      <section
        data-test-id="ai-text-improver/improvement-variant"
        ref={ref}
        className={cm.improvementVariant}
      >
        <p
          data-test-id="ai-text-improver/improvement-variant-value"
          className={cm.improvementVariant__text}
        >
          {text}
        </p>

        <button
          onClick={() => onSelect(text)}
          className={cm.improvementVariant__applyButton}
          aria-label={l.translate('Apply this variant')}
          data-test-id="ai-text-improver/improvement-variant-apply"
        />
      </section>
    )
  },
)
